module.exports = "/images/vendor/flag-icon-css/flags/4x3/gs.svg?0ee2d8c9dbe38540ec7006706d31c903";